import { render, staticRenderFns } from "./communityIssuePerson.vue?vue&type=template&id=8b2ee01c&scoped=true&"
import script from "./communityIssuePerson.vue?vue&type=script&lang=js&"
export * from "./communityIssuePerson.vue?vue&type=script&lang=js&"
import style0 from "./communityIssuePerson.vue?vue&type=style&index=0&id=8b2ee01c&prod&lang=less&scoped=true&"
import style1 from "./communityIssuePerson.vue?vue&type=style&index=1&id=8b2ee01c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2ee01c",
  null
  
)

export default component.exports